<template>
  <div class="loading">
    <div class="loading__icon">
      <div class="loading__fire">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 109.8 151.4">
          <path d="M109.7 96.6c.7-13.5-3.9-35.6-15.3-53.6-.3-.5-.8-.3-.7.2.8 2.8.9 7.7-3.4 7.4-7.8-.5.3-17.1-16.8-28.6-.2-.1-.4-.1-.5 0-.1.1-.1.3 0 .4 1.2 2.2 1.9 9.1-.8 11.5-2.2 1.9-6.1 1.4-10-4.8-6.4-10.4-4-21.5.4-28.4.3-.6-.2-.8-.6-.7-23.4 7.8-28.1 35.4-33.1 45.4-.8 1.7-1.6 2.6-3 2.5-4.3-.3-1.2-9.4.3-12.6.1-.2 0-.4-.1-.5-.1-.1-.3 0-.4.1C13.5 47.5 2.6 69 .5 88.9c.1-.5-.2 1.6-.3 3.2 0 .6-.1 1.2-.1 1.8-.1.8-.1 1.5-.1 2.3-.2 30.3 24.2 55 54.6 55.2 30.2.2 54.9-24.1 55.2-54.3 0-.2-.1-.4-.1-.5zm-55 25.4c-14-.1-25.3-11.6-25.2-25.7.1-14 11.6-25.3 25.7-25.2 14 .1 25.3 11.6 25.2 25.6-.2 14.2-11.7 25.5-25.7 25.3z"></path>
        </svg>
      </div>
      <div class="loading__activity"></div>
    </div>
    <span class="loading__title"> {{ $t('loading.title') }} </span>
    <span class="loading__subtitle"> {{ $t('loading.subtitle') }} </span>
  </div>
</template>

<script>
import i18n from '@/i18n';

export default {
  data() {
    return {
      i18n,
    };
  },
};
</script>

<style lang="scss">
.loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
  position: absolute;
  top: 71px;
  width: 100%;
  min-height: 90%;
  background: #F7F9FA;

  &__title {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 300;
    font-size: 24px;
    line-height: 120%;
    text-align: center;
    color: #282C2F;
    margin-top: 20px;
  }

  &__subtitle {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 150%;
    text-align: center;
    color: #282C2F;
    margin-top: 8px;
  }

  &__fire svg {
    height: 28px;
    left: 50%;
    margin-left: -8px;
    margin-top: -15px;
    position: absolute;
    top: 50%;
    width: 18px;
    fill: #f04e23 !important;
  }

  &__icon {
    height: 3rem;
    margin: .75rem;
    position: relative;
    width: 3rem;
  }

  &__activity {
    animation: spin 500ms linear infinite;
    border: .0625rem solid transparent;
    border-left-color: #c9ced4;
    border-radius: 50%;
    border-top-color: #c9ced4;
    display: block;
    height: 3rem;
    margin: 0 auto;
    position: relative;
    width: 3rem;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/screens/Status/components/Loading.vue